module.exports = __webpack_public_path__ + "static/media/ftm.9c71a035.svg";